var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeVolumeAmount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1705_107876)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9547 22.0323H33.0462C35.1069 24.5263 38.5927 29.4757 38.5927 34.5504C38.5927 38.951 35.2417 41.2909 32.8151 41.2909H23.1858C20.7592 41.2909 17.4082 38.951 17.4082 34.5504C17.4082 29.4757 20.894 24.5263 22.9547 22.0323ZM28.0941 26.0856C28.3753 26.0856 28.6564 26.3668 28.6564 26.6479V27.3039H30.3432C30.6244 27.3039 30.9055 27.5851 30.9055 27.8662V28.0536C30.9055 28.3348 30.6244 28.6159 30.3432 28.6159H26.6884C26.4073 28.6159 26.1261 28.8033 25.9387 28.9908C25.6576 29.2719 25.5639 29.553 25.5639 29.8342C25.5639 30.1153 25.7513 30.3965 25.9387 30.5839C26.1261 30.7713 26.4073 30.9587 26.6884 30.9587H29.2187C29.8747 30.9587 30.5307 31.1462 30.9992 31.7085C31.4678 32.0833 31.7489 32.7393 31.7489 33.3953C31.7489 34.0513 31.5615 34.6136 31.1867 35.0821C30.8118 35.5507 30.1558 35.8318 29.4998 35.8318H28.8438V36.6753C28.8438 36.9564 28.5627 37.2375 28.2815 37.2375H28.0004C27.7193 37.2375 27.4381 36.9564 27.4381 36.6753V35.8318H25.3764C25.0953 35.8318 24.8141 35.5507 24.8141 35.2696V34.9884C24.8141 34.7073 25.0016 34.5199 25.2827 34.5199H29.2187C29.5935 34.5199 29.8747 34.4261 30.0621 34.3324C30.3432 34.0513 30.437 33.7701 30.437 33.489C30.437 33.1142 30.2495 32.833 30.0621 32.6456C29.781 32.3644 29.4998 32.2707 29.2187 32.2707H26.6884C26.1261 32.2707 25.4701 31.9896 25.0016 31.521C24.533 31.1462 24.2519 30.4902 24.2519 29.8342C24.2519 29.1782 24.533 28.5222 25.0016 28.1473C25.3764 27.6788 26.0324 27.3976 26.6884 27.3976H27.3444V26.6479C27.3444 26.3668 27.5318 26.0856 27.813 26.0856H28.0941Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.554 20.492H32.4515L34.6373 16.1107C34.7384 15.9081 34.7648 15.6764 34.7119 15.4563C34.6591 15.2361 34.5304 15.0417 34.3485 14.907C34.1658 14.7708 33.9407 14.7038 33.7133 14.7179C33.4858 14.732 33.2707 14.8263 33.1063 14.984C32.4762 15.4754 31.6894 15.7217 30.8915 15.6773C30.0983 15.7212 29.3157 15.4786 28.6864 14.9937C28.506 14.8143 28.262 14.7136 28.0076 14.7136C27.7532 14.7136 27.5091 14.8143 27.3287 14.9937C26.6973 15.4816 25.9106 15.7245 25.114 15.6773C24.3207 15.7212 23.5381 15.4786 22.9088 14.9937C22.747 14.8306 22.5322 14.7307 22.3032 14.7121C22.0742 14.6936 21.8461 14.7575 21.6601 14.8923C21.4741 15.0272 21.3424 15.2241 21.2889 15.4475C21.2354 15.6709 21.2635 15.9061 21.3681 16.1107L23.554 20.492Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1705_107876",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVolumeAmount);
export default __webpack_public_path__ + "static/media/Home_Volume_Amount.08a3c6de822178d76aa540cdf7a20c37.svg";
export { ForwardRef as ReactComponent };